import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import CompanyUserListForm from '@src/features/tenant/company-user/CompanyUserListForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function CompanyUserList() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN]}>
      <TenantDefaultLayout>
        <CommonHelmet />
        <CompanyUserListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default CompanyUserList;
